export enum TypologypropertyType {
  SELECT = 'select',
  // legacy
  APARTMENT = 'apartment',
  HOUSE = 'house',
  STORE = 'store',
  SHED = 'shed',
  COMMERCIAL_BUILDING = 'commercial_building',
  COMMERCIAL_SPACE = 'commercial_space',
  LOFT = 'loft',
  FLAT = 'flat',
  ENTERPRISE = 'enterprise',
  LAND = 'land',
  LOT = 'lot',
  // v2 — imóveis / modalidades
  SALA_PAVIMENTO_COMERCIAL = 'sala_pavimento_comercial',
  VAGA_GARAGEM = 'vaga_garagem',
  LOTE_HABITACIONAL_UNIFAMILIAR = 'lote_habitacional_unifamiliar',
  PREDIO = 'predio',
  GLEBA_URBANA = 'gleba_urbana',
  EMPREENDIMENTO_URBANO = 'empreendimento_urbano',
  GRUPO_ASSEMELHADOS_PRONTO = 'grupo_assemelhados_pronto',
  GRUPO_ASSEMELHADOS_CONSTRUIR = 'grupo_assemelhados_construir',
  IMOVEL_RURAL = 'imovel_rural',
  AVALIACOES_ATIPICAS = 'avaliacoes_atipicas',
  AVALIACOES_MASSA = 'avaliacoes_massa',
  CONSULTORIA_AVALIACAO = 'consultoria_avaliacao',
  // v2 — serviços / atividades
  VISTORIA_CONSTATACAO_EXISTENCIA = 'vistoria_constatacao_existencia',
  DILIGENCIA_IMOBILIARIA = 'diligencia_imobiliaria',
  DILIGENCIA_INVESTIGATIVA = 'diligencia_investigativa',
  VISTORIA_ESTADO_CONSERVACAO = 'vistoria_estado_conservacao',
  VISTORIA_TECNICA_INSPECAO = 'vistoria_tecnica_inspecao',
  VISTORIA_MEDICAO_OBRA = 'vistoria_medicao_obra',
  SOLUCAO_360 = 'solucao_360',
}

const TYPOLOGY_PROPERTY_TYPE_LABELS: Record<TypologypropertyType, string> = {
  [TypologypropertyType.SELECT]: 'selecione uma opção',
  // legacy
  [TypologypropertyType.HOUSE]: 'casa',
  [TypologypropertyType.APARTMENT]: 'apartamento',
  [TypologypropertyType.COMMERCIAL_SPACE]: 'sala comercial',
  [TypologypropertyType.STORE]: 'loja',
  [TypologypropertyType.SHED]: 'galpão',
  [TypologypropertyType.COMMERCIAL_BUILDING]: 'prédio comercial',
  [TypologypropertyType.LOFT]: 'loft',
  [TypologypropertyType.FLAT]: 'flat',
  [TypologypropertyType.ENTERPRISE]: 'empreendimento',
  [TypologypropertyType.LAND]: 'terreno',
  [TypologypropertyType.LOT]: 'lote',
  // v2 — imóveis / modalidades (labels do handoff §3.5)
  [TypologypropertyType.SALA_PAVIMENTO_COMERCIAL]:
    'sala ou pavimento comercial',
  [TypologypropertyType.VAGA_GARAGEM]: 'vaga de garagem',
  [TypologypropertyType.LOTE_HABITACIONAL_UNIFAMILIAR]:
    'lote habitacional unifamiliar',
  [TypologypropertyType.PREDIO]: 'prédio',
  [TypologypropertyType.GLEBA_URBANA]: 'gleba urbana ou urbanizável',
  [TypologypropertyType.EMPREENDIMENTO_URBANO]:
    'empreendimento urbano de base imobiliária',
  [TypologypropertyType.GRUPO_ASSEMELHADOS_PRONTO]:
    'grupo de imóveis assemelhados – empreendimento pronto',
  [TypologypropertyType.GRUPO_ASSEMELHADOS_CONSTRUIR]:
    'grupo de imóveis assemelhados – empreendimento a construir',
  [TypologypropertyType.IMOVEL_RURAL]: 'imóvel rural',
  [TypologypropertyType.AVALIACOES_ATIPICAS]: 'avaliações atípicas',
  [TypologypropertyType.AVALIACOES_MASSA]: 'avaliações em massa',
  [TypologypropertyType.CONSULTORIA_AVALIACAO]:
    'consultoria em avaliação de imóveis',
  // v2 — serviços / atividades
  [TypologypropertyType.VISTORIA_CONSTATACAO_EXISTENCIA]:
    'vistoria de constatação de existência',
  [TypologypropertyType.DILIGENCIA_IMOBILIARIA]: 'diligência imobiliária',
  [TypologypropertyType.DILIGENCIA_INVESTIGATIVA]: 'diligência investigativa',
  [TypologypropertyType.VISTORIA_ESTADO_CONSERVACAO]:
    'vistoria de constatação do estado de conservação do ativo',
  [TypologypropertyType.VISTORIA_TECNICA_INSPECAO]:
    'vistoria técnica e inspeção do ativo',
  [TypologypropertyType.VISTORIA_MEDICAO_OBRA]: 'vistoria e medição de obra',
  [TypologypropertyType.SOLUCAO_360]:
    'avaliação + diligência imobiliária + vistoria de constatação do estado de conservação',
};

export const convertTypologyPropertyType = (
  typologyPropertyType: TypologypropertyType
): string => TYPOLOGY_PROPERTY_TYPE_LABELS[typologyPropertyType] ?? '';

export enum TypologyRuleKeyword {
  SELECT = 'select',
  UP_TO = 'up_to',
  OVER = 'over',
  BETWEEN = 'between',
}

export const convertTypologyRuleKeyword = (
  typologyRuleKeyword: TypologyRuleKeyword
): string => {
  let word = '';
  switch (typologyRuleKeyword) {
    case TypologyRuleKeyword.SELECT:
      word = 'selecione uma opção';
      break;
    case TypologyRuleKeyword.UP_TO:
      word = 'até';
      break;
    case TypologyRuleKeyword.OVER:
      word = 'a partir de';
      break;
    case TypologyRuleKeyword.BETWEEN:
      word = 'entre';
      break;
    default:
      word = '';
  }
  return word;
};

// ── v2 (REAL-3116) — enums do typology_group ──────────────────

// "Cobrança por" (handoff §3.1)
export enum BillingUnit {
  IMOVEL = 'imovel',
  TRABALHO = 'trabalho',
  PROJETO = 'projeto',
}

export const convertBillingUnit = (unit: BillingUnit): string => {
  switch (unit) {
    case BillingUnit.IMOVEL:
      return 'Imóvel';
    case BillingUnit.TRABALHO:
      return 'Trabalho';
    case BillingUnit.PROJETO:
      return 'Projeto';
    default:
      return '';
  }
};

// Categoria — agrupa a listagem (handoff §3.2)
export enum TypologyCategory {
  DILIGENCIAS = 'diligencias',
  AVALIACOES_URBANAS = 'avaliacoes_urbanas',
  VISTORIAS_INSPECOES = 'vistorias_inspecoes',
  SOLUCOES_360 = 'solucoes_360',
  AVALIACOES_RURAIS = 'avaliacoes_rurais',
  MEDICOES_PROJETOS = 'medicoes_projetos',
}

export const convertTypologyCategory = (category: TypologyCategory): string => {
  switch (category) {
    case TypologyCategory.DILIGENCIAS:
      return 'Diligências';
    case TypologyCategory.AVALIACOES_URBANAS:
      return 'Avaliações Urbanas';
    case TypologyCategory.VISTORIAS_INSPECOES:
      return 'Vistorias e Inspeções';
    case TypologyCategory.SOLUCOES_360:
      return 'Soluções 360°';
    case TypologyCategory.AVALIACOES_RURAIS:
      return 'Avaliações Rurais';
    case TypologyCategory.MEDICOES_PROJETOS:
      return 'Medições e Projetos';
    default:
      return '';
  }
};

// Forma de cálculo do valor (handoff §3.3)
export enum TypologyPriceType {
  FIXO = 'fixo',
  QHT = 'qht',
  VALOR_N = 'valor_n',
}

export const convertTypologyPriceType = (
  priceType: TypologyPriceType
): string => {
  switch (priceType) {
    case TypologyPriceType.FIXO:
      return 'Valor fixo';
    case TypologyPriceType.QHT:
      return 'Hora técnica (QHT)';
    case TypologyPriceType.VALOR_N:
      return 'Valor de N';
    default:
      return '';
  }
};

// Label do campo de valor conforme o price_type.
export const priceFieldLabel = (priceType: TypologyPriceType): string => {
  switch (priceType) {
    case TypologyPriceType.FIXO:
      return 'valor fixo (R$)';
    case TypologyPriceType.QHT:
      return 'valor da hora técnica (R$)';
    case TypologyPriceType.VALOR_N:
      return 'valor de N (R$)';
    default:
      return 'valor (R$)';
  }
};

// Tipo de laudo/relatório (handoff §3.4)
export enum ReportType {
  RELATORIO = 'relatorio',
  LAUDO = 'laudo',
  LAUDO_SIMPLIFICADO = 'laudo_simplificado',
  LAUDO_COMPLETO = 'laudo_completo',
  LAUDO_360 = 'laudo_360',
}

export const convertReportType = (reportType: ReportType): string => {
  switch (reportType) {
    case ReportType.RELATORIO:
      return 'Relatório';
    case ReportType.LAUDO:
      return 'Laudo';
    case ReportType.LAUDO_SIMPLIFICADO:
      return 'Laudo Simplificado';
    case ReportType.LAUDO_COMPLETO:
      return 'Laudo Completo';
    case ReportType.LAUDO_360:
      return 'Laudo Completo + Diligência + Vistoria';
    default:
      return '';
  }
};
